import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Caixa } from 'src/app/admihair/api/dto/caixa';
import { CaixaService } from 'src/app/admihair/service/caixa.service';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { ComandaService } from 'src/app/admihair/service/comanda.service';
import { Usuario } from 'src/app/admihair/api/dto/usuario';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { UsuarioService } from 'src/app/admihair/service/usuario.service';
import { ResumoCaixaGerenciar } from 'src/app/admihair/api/dto/resumo-caixa-gerenciar';
import { OverlayPanel } from 'primeng/overlaypanel';
import { DetalharContaCaixaGerenciar } from 'src/app/admihair/api/dto/detalhar-conta-caixa-gerenciar';
import { DetalharComandaGerenciar } from 'src/app/admihair/api/dto/detalhar-comanda-gerenciar';
import { RelatorioCaixaTotalComanda } from 'src/app/admihair/api/dto/relatorio-caixa-total-comanda';
import { RelatorioCaixaService } from 'src/app/admihair/service/relatorio-caixa.service';
import { Comanda } from 'src/app/admihair/api/dto/comanda';
import { CaixaGerenciar } from 'src/app/admihair/api/dto/caixa-gerenciar';
import { DespesaCaixaGerenciar } from 'src/app/admihair/api/dto/despesa-caixa-gerenciar';
import { RelatorioTransferenciaCaixa } from 'src/app/admihair/api/dto/relatorio-transferencia-caixa';

@Component({
  selector: 'app-caixa-gerenciar-editar',
  templateUrl: './caixa-gerenciar-editar.component.html',
  styleUrls: ['./caixa-gerenciar-editar.component.scss']
})
export class CaixaGerenciarEditarComponent extends AdmihairBaseComponent implements OnInit {

  @ViewChild('filter') filter!: ElementRef;
  loadingTable: boolean = true;
  id?: number;
  caixa?: Caixa;
  listaComandas: RelatorioCaixaTotalComanda[] = [];
  inputBusca: string = '';
  listaSitucoesStatus: SelectItem[] = [
    { label: 'TODAS', value: 'TODAS' },
    { label: 'ABERTAS', value: 'ABERTA' },
    { label: 'FECHADAS', value: 'FECHADA' }
  ];
  statusComandaSelecionado: string = 'TODAS';

  usuariosSelectItem: SelectItem[] = [{ label: 'TODOS', value: null }];
  usuarioSelecionado?: Usuario;

  labelAcaoCaixa: string = '';
  tooltipAcaoCaixa: string = '';
  iconeAcaoCaixa: string = '';
  loadingSpinnerAcaoCaixa: boolean = false;
  corBotaoAcaoCaixa: string = '';

  valorTotalCaixa: number = 0;
  resumoCaixa?: ResumoCaixaGerenciar;
  porcentagemComandaFechadas: string = '';
  porcentagemContaCaixa: string = '';
  porcentagemContaBanco: string = '';
  porcentagemContaAjuste: string = '';

  exibirSpinnerDetalhes: boolean = false;
  detalhesConta: DetalharContaCaixaGerenciar[] = [];
  detalhesComanda: DetalharComandaGerenciar[] = [];
  valorTotalDetalheConta: number = 0;

  listaDespesasCaixa: DespesaCaixaGerenciar[] = [];
  loadingTableDespesas: boolean = false;
  totalDespesas: number = 0;

  listaTransferenciasCaixa: RelatorioTransferenciaCaixa[] = [];
  loadingTableTransferencias: boolean = false;
  totalTransferencias: number = 0;


  dataAtual: Date = new Date();
  novaDataCaixaSelecionada?: Date; 
  exibirDialogAlterarDataCaixa: boolean = false;
  loadingSpinnerAlterarDataCaixa: boolean = false;

  loadingRelatorioBaixar: boolean = false;
  loadingRelatorioImprimir: boolean = false;

  constructor(private caixaService: CaixaService,
    private comandaService: ComandaService,
    private usuarioService: UsuarioService,
    private relatorioCaixaService: RelatorioCaixaService,
    private confirmationService: ConfirmationService,
    private activatedRouter: ActivatedRoute,
    erroService: ErroService,
    storageService: UtilStorageService) {
    super(erroService, storageService)
  }

  ngOnInit(): void {
    this.setExibirSpinnerPrincipal(true);
    this.permissaoEditar = this.verificarPermissao('PERM_EDITAR_GERENCIAR_CAIXA');
    this.carregarId();
    this.carregarCaixa();
  }

  carregarCaixa() {
    this.caixaService.buscarPorId(this.id).subscribe({
      next: (data: Caixa) => {
        this.caixa = data;
        this.obterLabelAcaoCaixa(data.status)
        this.listarResumoCaixa();
      },
      error: (err: any) => {
        this.setExibirSpinnerPrincipal(false);
        this.exibirMensagemErro(err);
      }
    })
  }

  

  listarResumoCaixa() {
    this.caixaService.listarResumoCaixa(this.getEmpresa().id, this.caixa?.dataCaixa).subscribe({
      next: (data: ResumoCaixaGerenciar) => {
        this.resumoCaixa = data;

        if (data.quantidadeComandaFechada && data.quantidadeTotalComanda) {
          this.porcentagemComandaFechadas =
            ((data.quantidadeComandaFechada / data.quantidadeTotalComanda) * 100).toFixed(2);
        } else {
          this.porcentagemComandaFechadas = '0.00';
        }
        this.calcularPorcentagensContas();
        this.listarUsuariosCaixa();
      },
      error: (err: any) => {
        this.setExibirSpinnerPrincipal(false);
        this.exibirMensagemErro(err)
      }
    })
  }

  

  listarUsuariosCaixa() {
    this.usuarioService.listarPorEmpresaEDataCaixa(this.getEmpresa().id, this.caixa?.dataCaixa).subscribe({
      next: (data: Usuario[]) => {
        data.forEach(usuario => this.usuariosSelectItem.push({ label: usuario.apelido, value: usuario }));
        this.listarRelatorioComandas();
      },
      error: (err: any) => {
        this.setExibirSpinnerPrincipal(false);
        this.exibirMensagemErro(err)
      }
    })
  }

  


  listarRelatorioComandas() {
    this.loadingTable = true;
    this.relatorioCaixaService.consultarRelotorioTotaisComanda(this.getEmpresa().id,
      this.caixa?.dataCaixa, this.statusComandaSelecionado, this.usuarioSelecionado?.id,
      this.inputBusca)
      .subscribe({
        next: (data: RelatorioCaixaTotalComanda[]) => {
          this.listaComandas = data;
          this.loadingTable = false;
          this.listarDespesasCaixa();
          

        },
        error: (err: any) => {
          this.loadingTable = false;
          this.setExibirSpinnerPrincipal(false);
          this.exibirMensagemErro(err);
        }
      })
  }

  listarDespesasCaixa() {
    this.caixaService.listarDespesasCaixa(this.getEmpresa().id, this.caixa?.dataCaixa).subscribe({
      next: (data: DespesaCaixaGerenciar[]) => {
        this.listaDespesasCaixa = data;
        this.calcularTotalDespesas();
        this.listarTransferenciasCaixa();
      },
      error: (err: any) => {
        this.setExibirSpinnerPrincipal(false);
        this.exibirMensagemErro(err);
      }
    })
  }

  listarTransferenciasCaixa() {
    this.caixaService.listarTransferenciasCaixa(this.getEmpresa().id, this.caixa?.dataCaixa).subscribe({
      next: (data: RelatorioTransferenciaCaixa[]) => {
        this.listaTransferenciasCaixa = data;
        this.calcularTotalTransferencias();
        this.setExibirSpinnerPrincipal(false);
      },
      error: (err: any) => {
        this.setExibirSpinnerPrincipal(false);
        this.exibirMensagemErro(err);
      }
    })
  }

  calcularTotalTransferencias() {
    for(const transferencia of this.listaTransferenciasCaixa) {
      this.totalTransferencias = this.totalTransferencias + (transferencia.valor ?? 0);
    }
  }

  calcularTotalDespesas() {
    for(const despesa of this.listaDespesasCaixa) {
      this.totalDespesas = this.totalDespesas + (despesa.valor ?? 0);
    }
  }


  executarAcaoCaixa() {
    if (this.caixa?.status === 'ABERTO' || this.caixa?.status === 'REABERTO') {
      this.fecharCaixa();
    } else {
      this.reabrirCaixa();
    }
  }


  fecharCaixa() {
    if (this.caixa) {
      this.loadingSpinnerAcaoCaixa = true;
      this.caixa.usuario = this.getUsuarioLogadoSistema();
      this.caixaService.fecharCaixaAdministrativo(this.caixa).subscribe({
        next: () => {
          this.loadingSpinnerAcaoCaixa = false;
          this.exibirMensagemSucesso();
          this.carregarCaixa();
        },
        error: (err: any) => {
          this.loadingSpinnerAcaoCaixa = false;
          this.exibirMensagemErro(err);
        }
      })

    }
  }

  reabrirCaixa() {
    if (this.caixa) {
      this.loadingSpinnerAcaoCaixa = true;
      this.caixa.usuario = this.getUsuarioLogadoSistema();
      this.caixaService.reabrirCaixaAdministrativo(this.caixa).subscribe({
        next: () => {
          this.exibirMensagemSucesso();
          this.loadingSpinnerAcaoCaixa = false;
          this.carregarCaixa();
        },
        error: (err: any) => {
          this.loadingSpinnerAcaoCaixa = false;
          this.exibirMensagemErro(err);
        }
      })

    }
  }

  carregarDetalharConta(event: any, overlay: OverlayPanel, tipoConta: string) {
    overlay.toggle(event);
    this.exibirSpinnerDetalhes = true;
    this.caixaService.consultarDetalhesPagamentoPorTipoContaEData(this.getEmpresa().id,
      this.caixa?.dataCaixa, tipoConta).subscribe({
        next: (data: DetalharContaCaixaGerenciar[]) => {
          this.detalhesConta = data;
          this.calcularValorTotalDetalheConta();
          this.exibirSpinnerDetalhes = false;

        },
        error: (err: any) => {
          this.exibirSpinnerDetalhes = false;
          this.exibirMensagemErro(err)
        }
      })

  }

  calcularValorTotalDetalheConta() {
    this.valorTotalDetalheConta = 0;
    for (const item of this.detalhesConta) {
      if (item.valor) {
        this.valorTotalDetalheConta = this.valorTotalDetalheConta + item.valor;
      }
    }
  }

  carregarDetalharComanda(event: any, overlay: OverlayPanel) {
    overlay.toggle(event);
    this.exibirSpinnerDetalhes = true;
    this.caixaService.consultarDetalhesComandaPorEmpresaEDataCaixa(this.getEmpresa().id,
      this.caixa?.dataCaixa).subscribe({
        next: (data: DetalharComandaGerenciar[]) => {
          this.detalhesComanda = data;
          this.exibirSpinnerDetalhes = false;
        },
        error: (err: any) => {
          this.exibirSpinnerDetalhes = false;
          this.exibirMensagemErro(err)
        }
      });
  }

  calcularPorcentagensContas() {
    this.valorTotalCaixa = 0;
    if (this.resumoCaixa) {
      const valorContaCaixa = this.resumoCaixa.valorTotalContaCaixa ?? 0;
      const valorContaBanco = this.resumoCaixa.valorTotalContaBanco ?? 0;
      const valorContaAjuste = this.resumoCaixa.valorTotalContaAjuste ?? 0;
      this.valorTotalCaixa = valorContaCaixa + valorContaBanco + valorContaAjuste;
      
      if (this.valorTotalCaixa > 0) {
        this.porcentagemContaCaixa = ((valorContaCaixa / this.valorTotalCaixa) * 100).toFixed(2);
        this.porcentagemContaBanco = ((valorContaBanco / this.valorTotalCaixa) * 100).toFixed(2);
        this.porcentagemContaAjuste = ((valorContaAjuste / this.valorTotalCaixa) * 100).toFixed(2);
      } else {
        this.porcentagemContaCaixa = "0.00";
        this.porcentagemContaBanco = "0.00";
        this.porcentagemContaAjuste = "0.00";
      }
    } else {
      this.porcentagemContaCaixa = "0.00";
      this.porcentagemContaBanco = "0.00";
      this.porcentagemContaAjuste = "0.00";
    }
  }

  

  buscar(event: Event) {
    this.inputBusca = (event.target as HTMLInputElement).value;
    this.listarRelatorioComandas();
  }

  limpar() {
    this.filter.nativeElement.value = '';
    this.inputBusca = '';
    this.statusComandaSelecionado = 'TODAS';
    this.listarRelatorioComandas();
  }


  carregarId() {
    const idParam = this.activatedRouter.snapshot.paramMap.get('id');
    if (idParam) {
      this.id = parseInt(idParam);
    }

  }

  reabrirComanda(comandaId: number) {
    this.confirmationService.confirm({
      message: 'Reabrir Comanda?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        const comandaDto: Comanda = {
          id: comandaId,
          usuario: this.getUsuarioLogadoSistema()
        }
        this.comandaService.reabrirComanda(comandaDto).subscribe({
          next: () => {
            this.carregarCaixa();
          },
          error: (err: any) => {
            this.exibirMensagemErro(err);
          }
        })

      }
    });
  }

  alterarDataCaixa() {
    const caixaDataAlteracaoDTO: CaixaGerenciar = {
      id: this.caixa?.id,
      novaDataCaixa: this.novaDataCaixaSelecionada,
      empresaId: this.getEmpresa().id,
      usuarioId: this.getUsuarioLogadoSistema().id
    }
    this.loadingSpinnerAlterarDataCaixa = true;
    this.caixaService.alterarDataCaixaAdministrativo(caixaDataAlteracaoDTO).subscribe({
      next: () => {
        this.loadingSpinnerAlterarDataCaixa = false;
        this.exibirDialogAlterarDataCaixa = false;
        this.exibirMensagemSucesso();
        this.carregarCaixa();

      },
      error: (err: any) => {
        this.loadingSpinnerAlterarDataCaixa = false;
        this.exibirDialogAlterarDataCaixa = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  obterLabelAcaoCaixa(status?: string) {
    if (status === 'ABERTO') {
      this.labelAcaoCaixa = 'Fechar';
      this.tooltipAcaoCaixa = 'Fechar o Caixa';
      this.iconeAcaoCaixa = 'pi pi-lock';
      this.corBotaoAcaoCaixa = 'p-button bg-blue-600'
    }
    if (status === 'FECHADO') {
      this.labelAcaoCaixa = 'Reabrir';
      this.tooltipAcaoCaixa = 'Reabrir o Caixa';
      this.iconeAcaoCaixa = 'pi pi-lock-open';
      this.corBotaoAcaoCaixa = 'p-button bg-green-600'

    }
    if (status === 'REABERTO') {
      this.labelAcaoCaixa = 'Fechar';
      this.tooltipAcaoCaixa = 'Fechar o Caixa';
      this.iconeAcaoCaixa = 'pi pi-lock';
      this.corBotaoAcaoCaixa = 'p-button bg-cyan-600'
    }
  }


  openComandaResumo(comandaId?: number) {
    const width = window.innerWidth * 0.4;
    const height = window.innerHeight * 0.8;
    const left = (window.innerWidth - width) / 2;
    const top = (window.innerHeight - height) / 2;

    const url = `${window.location.origin}/#/janela-empresa/comanda/${comandaId}`;
    const newWindow = window.open(
      url,
      '_blank',
      `width=${width},height=${height},left=${left},top=${top},menubar=no,toolbar=no,location=no,status=no`
    );

    newWindow?.addEventListener('keydown', (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        newWindow.close();
      }
    });
    newWindow?.addEventListener('load', () => {
      newWindow.document.body.style.overflowX = 'hidden';
    });
  }


  baixarRelatorio() {
    this.loadingRelatorioBaixar = true;
    this.baixarRelatorioOuImprimir('baixar');
  }

  imprimirRelatorio() {
    this.loadingRelatorioImprimir = true;
    this.baixarRelatorioOuImprimir('imprimir');
  }

  baixarRelatorioOuImprimir(acao: 'baixar' | 'imprimir') {
    
    const empresaId = this.getEmpresa().id;
    const dataCaixa = this.caixa?.dataCaixa;

    this.relatorioCaixaService.gerarPdf(empresaId, dataCaixa).subscribe({
      next: (response) => {
        const blob = new Blob([response], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);

        if(acao === 'baixar') {
          const a = document.createElement('a');
          a.href = url;
          a.download = `relatorio_caixa_${dataCaixa}.pdf`;
          a.click();
          a.remove();

        } else if (acao === 'imprimir') {
          const pdfWindow = window.open(url, '_blank');
          if(pdfWindow) {
            pdfWindow.addEventListener('load', () => pdfWindow.print());
          }

        }

        window.URL.revokeObjectURL(url);
        this.loadingRelatorioBaixar = false;
        this.loadingRelatorioImprimir = false;
      },
      error: (err: any) => {
        this.loadingRelatorioBaixar = false;
        this.loadingRelatorioImprimir = false;
        this.exibirMensagemErro(err);
      }
    })
  }

}
